import { State } from "@/store/modules/chat/index";
import { CHAT_TYPE } from "@/resources/constants/chat";

const setUserChat = (state: State, payload): void => {
  state.userChat = payload;
};
const setMessagingSession = (state: State, payload): void => {
  state.messagingSession = payload;
};
const setEndPointUrl = (state: State, payload): void => {
  state.endPointUrl = payload;
};
const setChatType = (state: State, payload: CHAT_TYPE): void => {
  state.chatType = payload;
};
const setMessages = (state: State, payload): void => {
  state.messages = payload;
};
const addNewMessage = (state: State, payload): void => {
  if (state.messages == undefined) state.messages = [];
  state.messages.push(payload);
};
const setUnSeenMessage = (state: State, payload): void => {
  state.unSeenMessages = payload;
};
const addMessages = (state: State, payload): void => {
  state.messages = [...state.messages, ...payload];
};
const addUnSeenMessage = (state: State, payload): void => {
  state.unSeenMessages.push(payload);
  localStorage.setItem("unSeenMessage", JSON.stringify(state.unSeenMessages));
};
const removeUnSeenMessage = (state: State, payload): void => {
  state.unSeenMessages = state.unSeenMessages.filter((a) => {
    switch (a.type) {
      case CHAT_TYPE.ONE_TO_ONE:
        return !a.id || a.id !== payload.id;
      case CHAT_TYPE.ROOM:
        return a.type !== payload.type;
      case CHAT_TYPE.SPACE:
        return a.type !== payload.type;
    }
  });
  localStorage.setItem("unSeenMessage", JSON.stringify(state.unSeenMessages));
};

const setNextToken = (state: State, payload: string | null): void => {
  state.nextToken = payload;
};

const setMinimizeChat = (state: State, payload: boolean): void => {
  state.minimizeChat = payload;
};

const setPinnedMessagesLength = (state: State, payload: number): void => {
  state.pinnedMessagesLength = payload;
};

export default {
  setUserChat,
  setMessagingSession,
  setEndPointUrl,
  setChatType,
  setMessages,
  addNewMessage,
  addUnSeenMessage,
  removeUnSeenMessage,
  setUnSeenMessage,
  setNextToken,
  addMessages,
  setMinimizeChat,
  setPinnedMessagesLength,
};
